<template>
  <v-container grid-list-md fluid>
    <v-layout row wrap>
      <v-flex md12>
        <data-table ref="tableAudit" @auditRow="audit" />
        <auditoria ref="auditModal" />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import DataTable from "@/views/bitacoras/reporteAuditoria/DataTable";
import Auditoria from "@/components/auditoria/Auditoria";

export default {
  name: "ReporteAuditoria"
  , components: {
    DataTable
    , Auditoria
  }
  , data() {
    return { view: { title: this.$t("view.bitacoras.reporteAuditoria.title") } };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , methods: {
    async audit(clave, dataTabla, dataDescripcion, dataRevision) {
      this.$refs.auditModal.loadAuditDetail(clave, dataTabla, dataDescripcion, dataRevision, dataRevision);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/bitacoras/reporteAuditoria/ReporteAuditoria.vue